import { Box, IconButton, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import Iconify from '../iconify';

const DisplayError = ({text, onClose}) => {


    if(!text) return null

    const _text = text?.message || text

    return ( 

        <Box sx={{
            background:red[100],
            border:`1px dashed ${red[300]}`,
            padding:1,
            borderRadius:1,
            mb:2,
            color:red[900],
            display:'flex',
            wrap:'no-wrap',
            alignItems:'center'
        }}>
            <Iconify icon='pajamas:error' color='error' />
            <Typography variant='subtitle2' color='text.primary'  sx={{
                fontWeight:400,
                marginLeft:4,
                flex:1
            }}>{_text}</Typography>
            <IconButton size='small' onClick={onClose}><Iconify icon='ic:round-close' /></IconButton>
        </Box>
     );
}
 
export default DisplayError;